// @flow
import * as React from 'react';
import styled from 'styled-components';
import Close from '../Icons/Close';

const AssistantCoachBar = styled.div`
	background: #6e16aa;
	position: relative;
	//left: 0;
	//top: 0;
	width: 100%;
	justify-content: center;
	align-items: center;
	color: #fff;
	padding: 10px 20px;
	font-size: 11px;
	z-index: 0;

	.assistant-coach-bar-content {
		//flex: 1 1;
		text-align: center;

		a {
			text-decoration: none;
		}
	}
	.assistant-coach-bar-content .text {
		font-weight: 700;
		margin-right: 10px;
	}
	.assistant-coach-bar-content .time-info {
		font-weight: 700;
		font-style: italic;
		margin-left: 10px;
	}
	.assistant-coach-bar-content .more {
		line-height: 35px;
		background: transparent;
		height: 35px;
		color: #fff;
		border: 1px solid #fff;
		padding: 0 1em;
		font-size: .65em;
		font-weight: 700;
		text-transform: uppercase;
		text-align: center;
		border-radius: .4em;
		letter-spacing: 1px;
		cursor: pointer;
		transition: all .2s ease-out;
	}
	@media (max-width: 999px) {
		.assistant-coach-bar-content .more {
			line-height: 17px;
		}
	}
	.assistant-coach-bar-content .more.active-btn,
	.assistant-coach-bar-content .more:hover {
		background: transparent;
		border-color: #fff;
		color: #fff;
	}
	@media (max-width: 999px) {
		.assistant-coach-bar-content .more {
			padding: 1em 0;
			font-size: .8em;
		}
	}
	.assistant-coach-bar-content .sign-up {
		line-height: 35px;
		background: transparent;
		height: 35px;
		color: #f8e71c;
		border: 1px solid #f8e71c;
		padding: 0 1em;
		font-size: .65em;
		font-weight: 700;
		text-transform: uppercase;
		text-align: center;
		border-radius: .4em;
		letter-spacing: 1px;
		cursor: pointer;
		transition: all .2s ease-out;
	}
	@media (max-width: 999px) {
		.assistant-coach-bar-content .sign-up {
			line-height: 17px;
		}
	}
	.assistant-coach-bar-content .sign-up.active-btn,
	.assistant-coach-bar-content .sign-up:hover {
		background: transparent;
		border-color: #f8e71c;
		color: #f8e71c;
	}
	@media (max-width: 999px) {
		.assistant-coach-bar-content .sign-up {
			padding: 1em 0;
			font-size: .8em;
		}
	}
	.assistant-coach-bar-content .btn {
		font-size: 11px;
		font-family: RLFont,sans-serif;
		font-weight: 700;
		padding: 0 10px;
		margin-left: 10px;
		display: inline-block;
		height: 22px;
		line-height: 22px;
	}
`;

const CloseButton = styled.button`
	cursor: pointer;
	background: rgba(0,0,0,0);
	border: none;
	outline: none;
	display: block;
	width: 10px;
	position: absolute;
	right: 20px;
	top: 50%;
	transform: translateY(-50%);
`;

type Props = {
	trial_days_to_end: number,
	is_coach_trial_end: boolean,
	with_trial: boolean,
	coach_trial_popup: boolean,
	handleClick: Function
};

export const CoachBanner = ({
	trial_days_to_end,
	is_coach_trial_end,
	with_trial,
	coach_trial_popup,
	handleClick
}: Props) => {
	const is_show_banner = with_trial && !coach_trial_popup;
	if (!is_show_banner) {
		return null;
	}

	let trial_coach_text = 'Your complimentary FREE Coach' +
		' trial is active <b class="time-info">Ends soon!</b>';

	if (trial_days_to_end <= 7) {
		trial_coach_text = 'Your complimentary FREE Coach' +
			' trial is almost over! <b class="time-info">Ends soon!</b>';
	}

	if (is_coach_trial_end && !coach_trial_popup) {
		trial_coach_text = 'Your complimentary FREE Coach' +
			' trial is over! Want to activate Coach?';

	}
	return (
		<AssistantCoachBar className="assistant-coach-bar">
			<div className="assistant-coach-bar-content">
				<span className="text" dangerouslySetInnerHTML={{ __html: trial_coach_text }} />
				<a href="/help/guidelines#coach" target="_blank" className="btn more js-more">
					FIND OUT MORE
				</a>
				<a href="/account/coach-settings" target="_blank" className="btn sign-up">
					SIGN UP TODAY
				</a>
			</div>
			<CloseButton
				onClick={handleClick}
				className="assistant-coach-bar-close"
			>
				<Close color="#fff" size={.625} />
			</CloseButton>
		</AssistantCoachBar>
	);
};

export default CoachBanner;


// WEBPACK FOOTER //
// ./src/components/CoachBanner/index.js